<template>
  <div id="document-sidebar-foldertreeitem">
    <div
      v-for="(folder, index) in folders"
      class="flex flex-col pl-6 p-0"
      :key="index"
    >
      <tree-template
        :folder="folder"
        :switchOpenMethod="toggleSwitchOpen"
        :selectedMethod="toggleTreeSelect"
        :isSelected="isSelected"
      >
        <template #child>
          <folder-tree-item :folders="folder.folders" />
        </template>
      </tree-template>
    </div>
  </div>
</template>

<script>
import TreeTemplate from "../../../tree/DocumentFolderTemplate"
import FolderTreeItem from "./DocumentFolderTreeItem"

import { createNamespacedHelpers } from "vuex";

const {
  mapActions: mapActionsOfenterpriseDocumentManager,
  mapMutations: mapMutationsOfenterpriseDocumentManager,
  mapState: mapStateOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");

export default {
  name: "FolderTreeItem",
  components: {
    TreeTemplate,
    FolderTreeItem,
  },
  props: {
    folders: { type: Array },
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "documentRootPath", "selectedSidebarItem", 
    ]),
  },
  methods: {
    ...mapActionsOfenterpriseDocumentManager([
      "fetchTreeFolders",
      "setSidebarSelected"
    ]),
    ...mapMutationsOfenterpriseDocumentManager([
      "SET_CURRENT_PATH",
      "SET_FOLDERS_IS_OPEN",
      "SET_FOLDERS_OPEN",
    ]),
    async toggleSwitchOpen (folder) {
      await this.fetchTreeFolders(folder)
      await this.SET_FOLDERS_IS_OPEN(folder);
    },
    setPathStringToArray (path) {
      const pathArray = path.replace(this.documentRootPath, "").split("/").map(item => { return { "name": item } })
      this.SET_CURRENT_PATH(pathArray);
    },
    async toggleTreeSelect (folder) {
      try {
        this.$vs.loading();
        await this.fetchTreeFolders(folder)
        const payload = {
          selected: folder.path,
          showPath: false,
          showFolder: true
        }
        await this.setSidebarSelected(payload)
        this.setPathStringToArray(folder.path)
        await this.SET_FOLDERS_OPEN(folder);
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        console.error(error)
        throw error;
      }
    },
    isSelected (path) {
      return this.selectedSidebarItem === path
    }
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/document-manager.scss";

#document-sidebar-foldertreeitem {
  .document-tree-item-selected {
    background: $aisea-pure-white;
    color: $aisea-blue;
  }
}
</style>